/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmbedTokenInfoDto } from '../../models/embed-token-info-dto';

export interface EmbedsValidateGet$Plain$Params {
  token?: string;
}

export function embedsValidateGet$Plain(http: HttpClient, rootUrl: string, params?: EmbedsValidateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmbedTokenInfoDto>> {
  const rb = new RequestBuilder(rootUrl, embedsValidateGet$Plain.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmbedTokenInfoDto>;
    })
  );
}

embedsValidateGet$Plain.PATH = '/embeds/validate';
